import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { HubConnectionBuilder, IHttpConnectionOptions, HubConnection } from '@microsoft/signalr';
import Cookies from 'js-cookie';
import { useStores } from 'stores';
import { config, TOKEN_KEY } from 'constants/common';

const options: IHttpConnectionOptions = {
  logMessageContent: false,
  accessTokenFactory: () => Cookies.get(TOKEN_KEY)!.slice('Bearer '.length),
};

export const useMessanger = () => {
  const [connectionRef, setConnection] = useState<HubConnection>();

  const {
    messageStore: { handleNewMessage },
  } = useStores();

  const createHubConnection = () => {
    const signalr = new HubConnectionBuilder()
      .withUrl(`${config.url.API_URL}/messenger`, options)
      .withAutomaticReconnect()
      .build();

    setConnection(signalr);
  };

  useEffect(() => {
    createHubConnection();
  }, []);

  useEffect(() => {
    if (connectionRef) {
      try {
        connectionRef.start().then(() => connectionRef.on('MessageReceived', handleNewMessage));
      } catch (error) {
        toast.error('Something wrong with sockets');
      }
    }

    return () => {
      connectionRef && connectionRef.stop();
    };
  }, [connectionRef]);
};
